module.exports = __webpack_public_path__ + "static/media/aporte_voluntariocon_fin_previsional.7108d749.png";